import React from 'react';
import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { AuthLayout } from '@shared/layouts';
import { useAuth } from '../../hooks/useAuth';

interface AuthRouteProps {
    children?: React.ReactNode;
}

export const AuthRoutes: React.FC<AuthRouteProps> = ({ children }) => {
    const { isAuthenticated, mfaStatus } = useAuth();
    const location = useLocation();

    // Handle MFA setup required
    if (location.pathname !== '/mfa/setup' && mfaStatus === 'setup_required') {
        return <Navigate to="/mfa/setup" state={{ from: location }} replace />;
    }

    // Handle MFA verification required
    if (location.pathname !== '/mfa/verify' && mfaStatus === 'required') {
        return <Navigate to="/mfa/verify" state={{ from: location }} replace />;
    }

    // Handle authenticated users trying to access auth pages
    // /mfa/recovery-codes is excluded: it is shown once after first-time enrolment
    if (isAuthenticated && ['/login', '/mfa/setup', '/mfa/verify'].includes(location.pathname)) {
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    // If children are provided, render them; otherwise render Outlet for nested routes
    return <AuthLayout>{children || <Outlet />}</AuthLayout>;
};
